import GamesSliderView from './games_slider_view';

export default GamesSliderView;
